// BONE HEALTH section — all 2026 assets (Bone Health folder + jpgs/).
import { pdf2026, thumb2026 } from "./assets";

const CAT = "Bone Health";

const boneHealthCards = [
  {
    title: "Protecting Your Bones Fact Sheet",
    // NOTE: the S3 PDF key has a trailing space before ".pdf".
    pdf: pdf2026(CAT, "Protecting Your Bones Fact Sheet .pdf"),
    thumb: thumb2026("Protecting Your Bones Fact Sheet -1.jpg"),
  },
  {
    title: "Calcium in Non-Dairy Foods",
    pdf: pdf2026(CAT, "Calcium in Non-Dairy Foods.pdf"),
    thumb: thumb2026("Calcium in Non-Dairy Foods.jpg"),
  },
];

export default boneHealthCards;
